/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_diagnostic_session_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 minutes pour comprendre votre projet et vos objectifs, identifier les obstacles qui freinent votre croissance, définir une feuille de route claire pour réussir. Sans engagement et 100% orienté action.`)
};

const en_diagnostic_session_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 minutes to understand your project and your goals, identify the obstacles that are holding back your growth, and define a clear roadmap for success. No commitment required and 100% action-oriented.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const diagnostic_session_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.diagnostic_session_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("diagnostic_session_description", locale)
	if (locale === "fr") return fr_diagnostic_session_description(inputs)
	return en_diagnostic_session_description(inputs)
};